import { keysForStringEnum } from "../utils/EnumUtils"

type EnumValue = { displayLabel: string }

// Weather Recording
export enum WeatherRecording {
    SOLAR_APOGEE_SP_420_SN1459 = "SOLAR_APOGEE_SP_420_SN1459",
    WEATHER_PROBE_AIMMS_30_SN031 = "WEATHER_PROBE_AIMMS_30_SN031",
}

export const weatherRecordingOptions: WeatherRecording[] = keysForStringEnum(WeatherRecording)
export const weatherRecordingValues: Record<WeatherRecording, EnumValue> = {
    [WeatherRecording.SOLAR_APOGEE_SP_420_SN1459]: { displayLabel: "Solar-Apogee SP-420(sn1458)" },
    [WeatherRecording.WEATHER_PROBE_AIMMS_30_SN031]: { displayLabel: "Weather Probe-AIMMS-30(sn031)" },
}

// No Fly Reason
export enum NoFlyReason {
    WEATHER = "WEATHER",
    MAINTENANCE = "MAINTENANCE",
    TROUBLESHOOTING = "TROUBLESHOOTING",
    OTHER = "OTHER",
}

export const noFlyReasonOptions: NoFlyReason[] = keysForStringEnum(NoFlyReason)
export const noFlyReasonValues: Record<NoFlyReason, EnumValue> = {
    [NoFlyReason.WEATHER]: { displayLabel: "Weather" },
    [NoFlyReason.MAINTENANCE]: { displayLabel: "Maintenance" },
    [NoFlyReason.TROUBLESHOOTING]: { displayLabel: "Troubleshooting" },
    [NoFlyReason.OTHER]: { displayLabel: "Other" },
}

// Weather Condition
export enum WeatherCondition {
    SUNNY = "SUNNY",
    PARTLY_CLOUDY = "PARTLY_CLOUDY",
    CLOUDY = "CLOUDY",
    RAIN = "RAIN",
    WIND = "WIND",
}

export const weatherConditionOptions: WeatherCondition[] = keysForStringEnum(WeatherCondition)
export const weatherConditionValues: Record<WeatherCondition, EnumValue> = {
    [WeatherCondition.SUNNY]: { displayLabel: "Sunny" },
    [WeatherCondition.PARTLY_CLOUDY]: { displayLabel: "Partly Cloudy" },
    [WeatherCondition.CLOUDY]: { displayLabel: "Cloudy" },
    [WeatherCondition.RAIN]: { displayLabel: "Rain" },
    [WeatherCondition.WIND]: { displayLabel: "Wind" },
}

// Ground Conditions
export enum GroundCondition {
    DRY = "DRY",
    WET = "WET",
    SNOW = "SNOW",
}

export const groundConditionOptions: GroundCondition[] = keysForStringEnum(GroundCondition)
export const groundConditionValues: Record<GroundCondition, EnumValue> = {
    [GroundCondition.DRY]: { displayLabel: "Dry" },
    [GroundCondition.WET]: { displayLabel: "Wet" },
    [GroundCondition.SNOW]: { displayLabel: "Snow" },
}

// Field Quicklook
export enum FieldQuicklook {
    KMZ_SWATCH_OUTPUT = "KMZ_SWATCH_OUTPUT",
    POS_PAC = "POS_PAC",
}

export const fieldQuicklookOptions: FieldQuicklook[] = keysForStringEnum(FieldQuicklook)
export const fieldQuicklookValues: Record<FieldQuicklook, EnumValue> = {
    [FieldQuicklook.KMZ_SWATCH_OUTPUT]: { displayLabel: ".kmz Swatch Output" },
    [FieldQuicklook.POS_PAC]: { displayLabel: "POSPac" },
}
